import React from 'react';
import { Nav } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { CLAIM_GROUP_SHOW_ALL_PROJECT } from '@rd-web-markets/market/dist/constants';
import { useTranslation } from 'react-i18next';
const MyClaimClaimGroupsNavigationDefault = _ref => {
  let {
    page,
    accountType
  } = _ref;
  const user = useSelector(state => state.auth.user);
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Nav, {
    variant: "tabs"
  }, (accountType === 'customer' || accountType === 'accountant') && /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement("h1", {
    className: "text-primary mb-4"
  }, t('claim_groups'))), accountType !== 'customer' && accountType !== 'accountant' && /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, {
    as: Link,
    active: page === 'my_claim_groups',
    to: "/".concat(accountType, "/my_claim_groups/")
  }, t('claim_groups'))), user.account_type !== 'customer' && user.account_type !== 'accountant' && !['/de', '/it'].includes(process.env.PUBLIC_URL) && /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, {
    as: Link,
    active: page === 'my_claims',
    to: "/".concat(accountType, "/my_claims/")
  }, t('claims'))), CLAIM_GROUP_SHOW_ALL_PROJECT && accountType !== 'customer' && user.account_type !== 'accountant' && /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, {
    as: Link,
    active: page === 'projects',
    to: "/".concat(accountType, "/projects/my")
  }, t('project_list')))));
};
export default MyClaimClaimGroupsNavigationDefault;